export default "__VITE_PUBLIC_ASSET__fc12b390__"